import { render, staticRenderFns } from "./leadershipcare.vue?vue&type=template&id=50be914e&scoped=true"
import script from "./leadershipcare.vue?vue&type=script&lang=js"
export * from "./leadershipcare.vue?vue&type=script&lang=js"
import style0 from "./leadershipcare.vue?vue&type=style&index=0&id=50be914e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be914e",
  null
  
)

export default component.exports